import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Wed Sep 26 2018
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import uniqueId from 'lodash/uniqueId';
import { action, observable } from 'mobx';
import { AlertType } from '../../components/info/Alert';
/**
 * MobX store for storing, removing and retreaving page errors
 */

export var PageErrorStore =
/*#__PURE__*/
function () {
  function PageErrorStore() {
    var _this = this;

    _classCallCheck(this, PageErrorStore);

    this.list = new Map();

    this.remove = function (id) {
      _this.list.delete(id);
    };

    this.set = function (error) {
      _this.list.set(uniqueId(), _this.message(error));
    };

    this.setMessage = function (error) {
      var err = {
        date: new Date(),
        text: error,
        type: AlertType.Error
      };

      _this.list.set(uniqueId(), err);
    };
  }

  _createClass(PageErrorStore, [{
    key: "message",
    value: function message(error) {
      var err = {
        date: new Date(),
        text: '',
        type: AlertType.Error
      }; // FIXME: System of messages translation

      if (error.response) {
        err.text = "".concat(error.response.data.code, " - ").concat(error.request.response.subcode);
      } else {
        err.text = error.message;
      }

      return err;
    }
  }]);

  return PageErrorStore;
}();

__decorate([observable, __metadata("design:type", Map)], PageErrorStore.prototype, "list", void 0);

__decorate([action, __metadata("design:type", Object)], PageErrorStore.prototype, "remove", void 0);

__decorate([action, __metadata("design:type", Object)], PageErrorStore.prototype, "set", void 0);

__decorate([action, __metadata("design:type", Object)], PageErrorStore.prototype, "setMessage", void 0);